import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './power-bi-constants';

export const powerBiReports = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_POWER_BI_REPORTS_REQUEST,
      actionTypes.FETCH_POWER_BI_REPORTS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_POWER_BI_REPORTS_SUCCESS]:
      (state, { payload }) => payload.items,
  },
  [],
);

export const isLoading = handleActions(
  {
    [actionTypes.FETCH_POWER_BI_REPORTS_REQUEST]:
      () => true,
    [combineActions(
      actionTypes.FETCH_POWER_BI_REPORTS_FAILURE,
      actionTypes.FETCH_POWER_BI_REPORTS_SUCCESS,
    )]: () => false,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_POWER_BI_REPORTS_REQUEST,
      actionTypes.FETCH_POWER_BI_REPORTS_SUCCESS,
    )]: () => ({}),
    [actionTypes.FETCH_POWER_BI_REPORTS_FAILURE]:
      (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  powerBiReports,
  isLoading,
  error,
});
